(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('InformeNuevoController', InformeNuevoController);

    InformeNuevoController.$inject = [
        '$stateParams', 'notificationService', 'reportingService', 'common', 'userService', '$rootScope', '$filter', '$state', 'genericDataService'
    ];


    function InformeNuevoController($stateParams, notificationService, reportingService, common, userService, $rootScope, $filter, $state, genericDataService) {

        /* PUBLIC VARIABLES */
        var vm = this;

        var id = $stateParams.id;
        vm.step = 0;
        vm.firstTimeFilters = true;
        vm.entidades = {
            list: [],
            selected: null
        };
        vm.modulos = {
            list: [{
                    id: 1,
                    nombre: 'Órdenes'
                },
                {
                    id: 2,
                    nombre: 'Facturas'
                },
                {
                    id: 3,
                    nombre: 'Flota'
                },
                {
                    id: 4,
                    nombre: 'Clientes'
                },
                {
                    id: 5,
                    nombre: 'Chóferes'
                }

            ],
            selected: null
        };
        vm.rels = []; 
        vm.relationsShow = [];
        vm.listTables = [1, 2];
        vm.grupos = {
            list: [{
                    id: 1,
                    nombre: 'Informes de órdenes'
                },
                {
                    id: 2,
                    nombre: 'Informes de facturas'
                }
            ],
            selected: {
                id: 1,
                nombre: 'Informes de órdenes'
            }
        };
        vm.favorito = false;
        vm.orderValues = {
            list: [{
                    id: 0,
                    nombre: 'Descendente'
                },
                {
                    id: 1,
                    nombre: 'Ascendente'
                }
            ],
        };
        vm.filter = {
            input: [],
            data: [],
            expanded: false,
            originalData: []
        };

        vm.initialModulos = [];
        vm.favoriteCheckbox = false;
        vm.fieldsSelected = [];
        vm.fields = [];
        vm.bitwise = [{
                id: 0,
                nombre: 'ninguno'
            },
            {
                id: 1,
                nombre: '=',
                caption: 'igual a'
            },
            {
                id: 2,
                nombre: '>',
                caption: 'mayor a'
            },
            {
                id: 4,
                nombre: '<',
                caption: 'menor a'
            },
            {
                id: 8,
                nombre: '!=',
                caption: 'diferente de'
            },
            {
                id: 16,
                nombre: 'between',
                caption: 'entre'
            },
            {
                id: 32,
                nombre: 'in',
                caption: 'contiene'
            }
        ];

        vm.predeterminated = false;
        vm.filters = [];
        vm.filtersSelected = [];
        vm.originalFilters = [];
        vm.getFilterData = getFilterData;
        vm.hasFilterData = hasFilterData;
        vm.relationsFields = [];
        vm.orders = [];
        vm.ordersSelected = [];
        vm.originalOrders = [];
        vm.searchText = "";
        vm.originalFields = []; //edit
        vm.loadingInformation = true;
        vm.loadingAssistant = false;
        vm.description = "";

        vm.title = "";

        /* PUBLIC FUNCTIONS */
        vm.processRelations = processRelations;
        vm.sendErrorRequire = sendErrorRequire;
        vm.changeStep = changeStep;
        vm.toggleFields = toggleFields;
        vm.untoggleFields = untoggleFields;
        vm.addFilter = addFilter;
        vm.removeFilter = removeFilter;
        vm.saveReport = saveReport;
        vm.addOrder = addOrder;
        vm.removeOrder = removeOrder;
        vm.customRelationFilter = customRelationFilter;
        vm.customFieldFilter = customFieldFilter;
        vm.getOperatorsData = getOperatorsData;
        vm.removeEmpresa = removeEmpresa;
        vm.addEmpresa = addEmpresa;
        vm.predeterminatedOriginalFiltersFilter = predeterminatedOriginalFiltersFilter;
        vm.addFrequentItem = addFrequentItem;
        vm.removeFrequentItem = removeFrequentItem;
        vm.openList = openList; 
        vm.selectType = selectType;

        (function () {
            loadData();
        })();

        // #region ---------------------------------------INITIAL FUNCTION-----------------------------
        function loadData() {
            var tempId = id;
            if (id == null) tempId = 0;
            reportingService.getRelations(tempId)
                .then(function (response) {
                    vm.initialModulos = response.data;
                    genericDataService.getEmpresasFromMaster().then(function (answer) {
                        vm.filter.originalData = answer.data;
                        vm.filter.data = JSON.parse(JSON.stringify(vm.filter.originalData));
                        vm.filter.input = JSON.parse(JSON.stringify(vm.filter.originalData));
                        if (id != null) {
                            reportingService.getById(id).then(function (response) {
                                vm.favorito = response.data.favorito == 1 ? true : false;
                                vm.grupos.selected = vm.grupos.list.find(x => x.id == response.data.grupoId);
                                for (var i = 0; i < response.data.reportsFields.length; i++) {
                                    var oldField = {
                                        id: response.data.reportsFields[i].fieldId,
                                        nombre: response.data.reportsFields[i].field.columnName,
                                        tableId: response.data.reportsFields[i].field.tableId
                                    }
                                    vm.originalFields.push(oldField);
                                }
                                for (var i = 0; i < response.data.reportFilters.length; i++) {
                                    if (response.data.reportFilters[i].fieldId == 255) {
                                        var res = response.data.reportFilters[i].value.split(';');
                                        if (res.length != vm.filter.data.length) {
                                            for (var j = 0; j < res.length; j++) {
                                                var idx = vm.filter.data.findIndex(x => x.empresaId == res[j]);
                                                vm.addEmpresa(vm.data[idx]);
                                            }
                                        }
                                    } else {
                                        var filter = {
                                            field: response.data.reportFilters[i].field,
                                            operator: vm.bitwise.find(x=> x.id == response.data.reportFilters[i].operando),
                                            data: response.data.reportFilters[i].value,
                                        };
                                        vm.originalFilters.push(filter);
                                    }
                                }
                                for (var i = 0; i < response.data.reportOrders.length; i++) {
                                    var order = {
                                        fieldId: response.data.reportOrders[i].fieldId,
                                        value: vm.orderValues.list[response.data.reportOrders[i].orden],
                                    };
                                    vm.originalOrders.push(order);
                                }
                                vm.firstTime = true;
                                vm.modulos.selected = vm.modulos.list.find(x => x.id == response.data.mainTable);
                                if (response.data.empresaMasterId == null || response.data.cloned != null) {
                                    vm.predeterminated = true;
                                    vm.title = response.data.name.trimRight() + 'CLONE';
                                    processRelationsPredeterminated();
                                } else {
                                    vm.title = response.data.name.trimRight();

                                }
                            });
                        } else {
                            vm.modulos.selected = vm.modulos.list[0];
                        }
                    });

                    vm.loadingAssistant = true;

                });
        }

        //  #endregion

        //#region ------------------------------------GENERAL FUNCTIONS--------------------------------
        function changeStep(num) {
            if (vm.step == 0 && num == 1) {
                if (vm.fieldsSelected.length == 0) {
                    sendErrorRequire('No ha seleccionado ningún campo!');
                } else {
                    vm.step += num;
                    processFilters();
                }
            } else if (vm.step == 2 && num == -1) {
                processStepBack();
                vm.step += num;
            } else if (vm.step == 1 && num == 1) {
                if (checkFiltersSelected() == 1) {
                    sendErrorRequire('Hay filtros incompletos!');
                } else {
                    vm.step += num;
                    processOrders();
                }
            } else if (vm.step == 2 && num == 1) {

                if (!checkOrdersSelected()) {
                    sendErrorRequire('Hay ordenaciones incompletas!');
                } else {
                    vm.step += num;
                    sendReport();
                }
            } else {
                vm.step += num;
            }
        }

        //function getOperatorsList(bw) {
        //    var list = [];
        //    vm.bitwise.forEach(function (bit) {
        //        if (bit.id != 0 && (bw & bit.id) == bit.id) {
        //            list.push(bit);
        //        }
        //    });
        //    return list;
        //}

        // function translateFilterOperando(op) {
        //     var oper = null;
        //     if (op == 1) oper = '=';
        //     else if (op == 2) {
        //         oper = '>';
        //     } else if (op == 4) {
        //         oper = '<';
        //     } else if (op == 8) {
        //         oper = '!=';
        //     } else if (op == 16) {
        //         oper = 'between';
        //     } else if (op == 32) {
        //         oper = 'in';
        //     } else {
        //         oper = 0;
        //     }

        //     return oper;
        // }

        function sendErrorRequire(messageValue) {
            notificationService.sendAppNotification({
                message: messageValue,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'error'
            });
        }


        //#endregion

        //#region --------------------------------CHECKING FUNCTIONS--------------------------
        function checkOrdersSelected() {
            if (vm.ordersSelected.length > 0 && common.isNullOrUndefined(vm.ordersSelected[0].order)) {
                vm.ordersSelected.splice(0, 1);
            }
            for (var i = 0; i < vm.ordersSelected.length; i++) {
                if (common.isNullOrUndefined(vm.ordersSelected[i].value)) return false;
            }
            return true;
        }

        function checkFiltersSelected() {
            for (var i = 0; i < vm.filtersSelected.length; i++) {
                if (common.isNullOrUndefined(vm.filtersSelected[i].field)) {
                    vm.filtersSelected.splice(i, 1);
                    i--;
                } else {
                    if (vm.filtersSelected[i].field.dataType == 'guid'){
                        if (vm.filtersSelected[i].dataArray == 0) return 1;
                    } 
                    else if (vm.filtersSelected[i].field.dataType == 'date' || vm.filtersSelected[i].field.dataType == 'datetime')  {
                        if (vm.filtersSelected[i].dateRange.fromDate == null || vm.filtersSelected[i].dateRange.toDate == null) return 1;
                    }
                    else if (vm.filtersSelected[i].operator == null) {
                        return 1;
                    } 
                    else {
                        if(common.isNullOrUndefined(vm.filtersSelected[i].data)) return 1; 
                    }
                }
            }
            return 0;
        }

        //#endregion

        //#region ---------------------------------TOGGLING FUNCTIONS-----------------------------------------------

        function toggleFields(item) {
            for (var i = 0; i < vm.relationsShow.length; i++) {
                var included = vm.relationsShow[i].fields.findIndex(x => x.id == item.id);
                if (included > -1) {
                    var rela = vm.fieldsSelected.findIndex(x => x.relatedTableId == vm.relationsShow[i].relatedTableId);
                    if (rela == -1) { //relation no encontrada --> añadirla
                        rela = vm.fieldsSelected.push(JSON.parse(JSON.stringify(vm.relationsShow[i]))) - 1;
                        vm.fieldsSelected[rela].fields = [];
                    }
                    vm.fieldsSelected[rela].fields.push(JSON.parse(JSON.stringify(item)));
                    vm.relationsShow[i].fields.splice(included, 1);
                    if (vm.relationsShow[i].fields.length == 0) {
                        vm.relationsShow.splice(i, 1);
                    }

                    break;
                }
            }
        }

        function untoggleFields(item) {
            for (var i = 0; i < vm.fieldsSelected.length; i++) {
                var included = vm.fieldsSelected[i].fields.findIndex(x => x.id == item.id);
                if (included > -1) {
                    var rela = vm.relationsShow.findIndex(x => x.relatedTableId == vm.fieldsSelected[i].relatedTableId);
                    if (rela == -1) {
                        rela = vm.relationsShow.push(JSON.parse(JSON.stringify(vm.fieldsSelected[i]))) - 1;
                        vm.relationsShow[rela].fields = [];
                    }
                    vm.relationsShow[rela].fields.push(JSON.parse(JSON.stringify(item)));
                    vm.fieldsSelected[i].fields.splice(included, 1);
                    if (vm.fieldsSelected[i].fields.length == 0) {
                        vm.fieldsSelected.splice(i, 1);
                    }
                    break;
                }
            }
        }
        //#endregion

        //#region -------------------------------------PROCESSING FUNCTIONS--------------------------------

        function processRelationsPredeterminated() {
            for (var i = 0; i < vm.initialModulos.length; i++) {
                vm.initialModulos[i].show = false;
                vm.relationsShow.push(JSON.parse(JSON.stringify(vm.initialModulos[i])));
            }
            for (var i = 0; i < vm.originalFields.length; i++) {
                vm.toggleFields(vm.originalFields[i]);
            }
        }

        function processRelations() {
            if (vm.predeterminated == true) return;
            vm.relationsShow = [];
            vm.fieldsSelected = [];

            for (var i = 0; i < vm.initialModulos.length; i++) {
                vm.initialModulos[i].show = false;
                if (vm.initialModulos[i].mainTableId == vm.modulos.selected.id) vm.relationsShow.push(JSON.parse(JSON.stringify(vm.initialModulos[i])));
            }
            if (vm.firstTime == true) {
                vm.firstTime = false;
                for (var i = 0; i < vm.originalFields.length; i++) {
                    vm.toggleFields(vm.originalFields[i]);
                }
            }
        }

        function openList(e) {
            $(e.currentTarget).siblings("div").toggle();
            e.stopPropagation();
        }

         function selectType(item) {
            if(item.field == null) return 0;
            else {
                if (item.field.dataType == 'datetime' || item.field.dataType == 'date'){
                    return 1;
                } 
                else if (item.field.dataType == 'guid') {
                    return 2;
                } 
                else if (item.field.data != null && item.operator != null) {
                    return 3;
                } 
                else if (item.field.data == null && item.operator != null && item.operator.id == 32) {
                    return 4;
                } 
                else if (item.field.data == null && item.operator != null && item.operator.id != 32) {
                    return 5;
                } 
            }

            
         }


        function processOrders() {
            vm.orders = [];
            //getting possible ordenation fields
            for (var i = 0; i < vm.fieldsSelected.length; i++) {
                for (var j = 0; j < vm.fieldsSelected[i].fields.length; j++) {
                    vm.orders.push(JSON.parse(JSON.stringify(vm.fieldsSelected[i].fields[j])));
                    vm.orders[vm.orders.length - 1].tableDescription = vm.fieldsSelected[i].relatedTable.description;
                }
            }

            //checking if filtersselected still possible
            for (var i = 0; i < vm.ordersSelected.length; i++) {
                var idx = vm.orders.findIndex(x => x.id == vm.ordersSelected[i].order);
                if (idx > -1) {
                    vm.ordersSelected[i].order = vm.orders[idx];
                } else {
                    vm.ordersSelected.splice(i, 1);
                    i--;
                }
            }

            if (id != null) {
                for (var i = 0; i < vm.originalOrders.length; i++) {
                    var idx = vm.orders.findIndex(x => x.id == vm.originalOrders[i].fieldId);
                    if (idx > -1) {
                        var it = vm.ordersSelected.findIndex(x => x.order.id == vm.originalOrders[i].fieldId);
                        if (it == -1) {
                            var temp = {
                                order: vm.orders[idx],
                                value: vm.originalOrders[i].value
                            }
                            vm.ordersSelected.push(temp);
                        }
                    }
                }
            }
        }

        function processFilters() {
            var rels = [];
            for(var i = 0; i < vm.rels.length; i++) { //borrar los que no esten 
                var idx = vm.fieldsSelected.findIndex(x=> x.relatedTableId == vm.rels[i]);
                if(idx == -1 && vm.rels[i] != vm.modulos.selected.id) {
                    for(var j = 0; j < vm.filters.length; ++j) {
                        if(vm.filters[j].tableId == vm.rels[i]) {
                            for(var x = 0; x < vm.filtersSelected.length; x++) {
                                if(vm.filtersSelected[x].field.tableId == vm.filters[j].tableId) {
                                    vm.filtersSelected.splice(x, 1); 
                                    x--; 
                                }
                            }
                            vm.filters.splice(j , 1); 
                            j--; 
                        }
                    }
                    vm.rels.splice(i, 1);
                    --i; 
                }
            }
            if (vm.rels.includes(vm.modulos.selected.id)== false) {
                rels.push(vm.modulos.selected.id);
                vm.rels.push(vm.modulos.selected.id); 
            } 
            for (var i = 0; i < vm.fieldsSelected.length; i++) {
                if (vm.rels.includes(vm.fieldsSelected[i].relatedTableId) == false) {
                    vm.rels.push(vm.fieldsSelected[i].relatedTableId); 
                    rels.push(vm.fieldsSelected[i].relatedTableId);
                }
            }
            if(rels.length > 0){
                reportingService.getFilters(rels, vm.modulos.selected.id).then(function (response) {
                    for(var i = 0; i < response.data.length; i++) {
                            vm.filters.push(response.data[i]);
                            vm.filters[vm.filters.length-1].tracted = false; 
                    }
                    //setting bitwise list
                    for (var j = 0; j < vm.filters.length; j++) {
                        if(vm.filters[j].tracted == false) {

                            vm.filters[j].operators = [];
                            vm.bitwise.forEach(function (bit) {
                                if (bit.id != 0 && (vm.filters[j].bitwise & bit.id) == bit.id) {
                                    vm.filters[j].operators.push(bit);
                                }
                            });
                            if (vm.filters[j].dataType == 'guid') {
                                var count = 0;
                                for (var i = 0; i < vm.filters[j].data.length; i++) {
                                    vm.filters[j].data[i].group = false;
                                    if (vm.filters[j].columnExtendedId != 314) vm.filters[j].data[i].show = true;
                                    else vm.filters[j].data[i].show = false;                                    vm.filters[j].data[i].selected = false;
                                    if (i == 0 || (vm.filters[j].data[i].groupBy != vm.filters[j].data[i - 1].groupBy)) {
                                        vm.filters[j].data.splice(i, 0, {
                                            nombre: vm.filters[j].data[i].groupBy,
                                            value: '0',
                                            group: true,
                                            show: true,
                                            selected: 0
                                        });
                                        ++i;
                                        if (i != 1) {
                                            vm.filters[j].data[count].value = i - count - 2;
                                            count = i - 1;
                                        }
                                    }
                                    if (i == vm.filters[j].data.length - 1) {
                                        vm.filters[j].data[count].value = vm.filters[j].data.length - count - 1;
                                    }
                                }
                            }
                        }
                    }

                    //adding old filters to filtersselected if they are not there
                    if(vm.firstTimeFilters == true) {
                        vm.firstTimeFilters = false; 
                        for (var i = 0; i < vm.originalFilters.length; i++) {
                            var idx = vm.filters.findIndex(x => x.columnExtendedId == vm.originalFilters[i].field.columnExtendedId);
                            if (idx > -1) {
                                var temp = {
                                    field: vm.filters[idx],
                                    operator: vm.filters[idx].operators.find(x => x.id == vm.originalFilters[i].operator.id),
                                    data: null,
                                    expanded: false,
                                    dataArray: 0,
                                    dateRange: $.extend({}, common.defaultDateRangePickerOptions)
                                };
                                if (temp.field.data != null && temp.operator.id != 32) { //como estado
                                    temp.data = vm.filters[idx].data.find(x => x.value == vm.originalFilters[i].data);
                                } else if (temp.field.data != null && temp.operator.id == 32) { //es un guid
                                    var res = vm.originalFilters[i].data.split(';');
                                    if (!(res.length == 1 && res[0] == 'null')) {

                                        for (var x = 0; x < res.length; x++) {
                                            temp.dataArray.push(temp.field.data.find(p => p.id == res[x]));
                                            temp.field.data.splice(temp.field.data.findIndex(p => p.id == res[x]), 1);
                                        }
                                    }
                                } else if (temp.field.dataType == 'datetime' || temp.field.dataType == 'date') {
                                    temp.dateRange.fromDate = moment().subtract(1, 'years');
                                    temp.dateRange.toDate = moment();
                                } else { //valor de texto
                                    temp.data = vm.originalFilters[i].data;
                                }
                                vm.filtersSelected.push(temp);
                            }
                        }
                    }
                    
                });
            }
        }

        function processStepBack() {
            for (var i = 0; i < vm.ordersSelected.length; i++) {
                vm.ordersSelected[i].order = vm.ordersSelected[i].order.id;
            }
        }

         function saveSelectedFilters() {
             for (var i = 0; i < vm.filtersSelected.length; i++) {
                 vm.filtersSelected[i].field = vm.filtersSelected[i].field.columnExtendedId;
             }
         }
        //#endregion

        //#region -----------------------------------ADD FUNCTIONS---------------------------
        function addOrder() {
            var order = {
                order: null,
                value: null,
            }
            vm.ordersSelected.unshift(order);
        }

        function addFilter() {
            var filter = {
                fieldId: null,
                data: "",
                operator: null,
                expanded: false,
                dataArray: 0,
                text: '',
                dateRange: $.extend({}, common.defaultDateRangePickerOptions), 
            };
            filter.dateRange.fromDate = moment().subtract(1, 'years');
            filter.dateRange.toDate = moment();

            vm.filtersSelected.unshift(filter);
        }

        function addFrequentItem(item, option) {
            if (option.group == false) {
                if (option.selected == false) {
                    option.show = true;
                    option.selected = true;
                    item.dataArray += 1;
                    for (var i = 0; i < item.field.data.length; i++) {
                        if (item.field.data[i].group == true && item.field.data[i].nombre == option.groupBy) {
                            item.field.data[i].selected += 1;
                            if (item.field.data[i].selected == item.field.data[i].value) {
                                for (var j = 0; j < item.field.data.length; j++) {
                                    if (item.field.data[j].group == false && item.field.data[j].groupBy == item.field.data[i].nombre) {
                                        item.field.data[j].show = false;
                                    }
                                }
                            }
                            break;
                        }
                    }
                } else {
                    item.dataArray -= 1;
                    if (item.field.columnExtendedId == 314) option.show = false;
                    option.selected = false;
                    for (var i = 0; i < item.field.data.length; i++) {
                        if (item.field.data[i].group == true && (item.field.data[i].nombre == option.groupBy)) {
                            item.field.data[i].selected -= 1;
                            if (item.field.data[i].selected == (item.field.data[i].value - 1)) {
                                for (var j = 0; j < item.field.data.length; j++) {
                                    if ((item.field.data[j].group == false) && (item.field.data[j].groupBy == item.field.data[i].nombre) && (item.field.data[j].selected == true)) {
                                        item.field.data[j].show = true;
                                    }
                                }
                            }
                            break;
                        }
                    }
                }
            } else {
                if (option.selected != option.value) {
                    for (var i = 0; i < item.field.data.length; i++) {
                        if (option.nombre == item.field.data[i].groupBy) {
                            if (item.field.data[i].selected == false) {
                                option.selected += 1;
                                item.dataArray += 1;
                                item.field.data[i].selected = true;
                            }
                            if (item.field.columnExtendedId == 314) item.field.data[i].show = false;
                        }
                    }

                } else {

                    option.selected = 0;
                    for (var i = 0; i < item.field.data.length; i++) {
                        if (item.field.data[i].group == false && item.field.data[i].groupBy == option.nombre) {
                            if (item.field.columnExtendedId == 314) item.field.data[i].show = false;
                            item.field.data[i].selected = false;
                            item.dataArray -= 1;
                        }
                    }
                }

            }
        }
        //#endregion

        //#region -----------------------------------REMOVE FUNCTIONS---------------------------
        function removeOrder(index) {
            vm.ordersSelected.splice(index, 1);
        }

        function removeFilter(index) {
            vm.filtersSelected.splice(index, 1);
        }

        function removeFrequentItem(item, option) {
             if (option.group == false) {
                 item.dataArray -= 1;
                 option.show = false;
                 for (var i = 0; i < length; i++) {
                     if (item.field.data[i].group == true && item.field.data[i].groupBy == option.groupBy) {
                         item.field.data[i].selected -= 1;
                     }
                 }
             } else {
                 option.selected = 0;
                 for (var i = 0; i < item.field.data.length; i++) {
                     if (item.field.data[i].group == false && item.field.data[i].groupBy == option.nombre) {
                         item.field.data[i].show = false;
                         item.dataArray -= 1;
                     }
                 }
             }
        }
        //#endregion

        //#region ---------------------------ADAPTING FUNCTIONS----------------------------

        function adaptFilters() {
            var filters = [];
            for (var i = 0; i < vm.filtersSelected.length; i++) {
                var filter = {
                    id: null,
                    operando: '',
                    value: ''
                }
                filter.id = vm.filtersSelected[i].field.columnExtendedId;

                if (vm.filtersSelected[i].field.dataType == 'datetime' || vm.filtersSelected[i].field.dataType == 'date') {
                    var dateTimeFrom = new Date(vm.filtersSelected[i].dateRange.fromDate);
                    var dateTimeTo = new Date(vm.filtersSelected[i].dateRange.toDate);
                    var string = moment(dateTimeFrom).format('YYYYMMDD');
                    string += moment(dateTimeTo).format('YYYYMMDD');
                    filter.operando = 'between';
                    filter.value = string;
                } else if (vm.filtersSelected[i].field.dataType == 'guid') {
                    filter.operando = 'in';
                    for (var j = 0; j < vm.filtersSelected[i].field.data.length; j++) {
                        if (vm.filtersSelected[i].field.data[j].selected == true && vm.filtersSelected[i].field.data[j].group == false) {
                            filter.value += vm.filtersSelected[i].field.data[j].id + ';';
                        }
                    }
                    filter.value = filter.value.slice(0, -1);
                } else if (vm.filtersSelected[i].field.data != null) {
                    filter.operando = vm.filtersSelected[i].operator.nombre;
                    filter.value = vm.filtersSelected[i].data.value;

                } else {
                    filter.operando = vm.filtersSelected[i].operator.nombre;
                    filter.value = vm.filtersSelected[i].data;
                }
                filters.push(filter);
            }
            var filterEmpresa = {
                id: 255,
                operando: 'in',
                value: ''
            };
            for (var i = 0; i < vm.filter.input.length; i++) {
                filterEmpresa.value += vm.filter.input[i].empresaId + ';';
            }
            filterEmpresa.value = filterEmpresa.value.slice(0, -1);
            filters.push(filterEmpresa);
            return filters;
        }

        function adaptOrders() {
            var orders = [];
            for (var i = 0; i < vm.ordersSelected.length; i++) {
                var order = {
                    id: null,
                    value: null
                }
                order.id = vm.ordersSelected[i].order.id;
                order.value = vm.ordersSelected[i].value.id;
                orders.push(order);
            }
            return orders;
        }

        function adaptFields() {
            var aux = {
                fields: [],
                relatedTables: []
            }
            for (var i = 0; i < vm.fieldsSelected.length; i++) {
                if (vm.fieldsSelected[i].relatedTableId != vm.modulos.selected.id) aux.relatedTables.push(vm.fieldsSelected[i].relatedTableId);
                for (var j = 0; j < vm.fieldsSelected[i].fields.length; j++) {
                    aux.fields.push(vm.fieldsSelected[i].fields[j].id);
                }
            }
            return aux;
        }

        //#endregion

        //#region ---------------------------------SENDING REPORTS FUNCTIONS------------------------

        function saveReport() {
            if (vm.title == "") {
                sendErrorRequire("No ha puesto nombre a su creación");
            } else {
                if (vm.predeterminated == false) {
                    var filters = adaptFilters();
                    var orders = adaptOrders();
                    var temp = adaptFields();
                    var fields = temp.fields;
                    var relatedTables = temp.relatedTables;
                    reportingService.saveReport(id, vm.title, fields, userService.userData.usuarioId, vm.modulos.selected.id, relatedTables, filters, orders, vm.grupos.selected.id, vm.favorito, vm.description).then(function (result) {
                        $state.go('flota.informes.listado');
                    });
                } else {
                    var filters = adaptFilters();
                    var orders = adaptOrders();
                    var temp = adaptFields();
                    var fields = temp.fields;
                    var relatedTables = temp.relatedTables;
                    reportingService.saveCloned(id, userService.userData.usuarioId, vm.title, fields, filters, orders, vm.grupos.selected.id, vm.favorito, vm.description).then(function (result) {
                        $state.go('flota.informes.listado');
                    });
                }
            }
        }

        function sendReport() {
            vm.loadingInformation = false;
            var filters = adaptFilters();
            var orders = adaptOrders();
            var temp = adaptFields();
            var fields = temp.fields;
            var relatedTables = temp.relatedTables;
            if (vm.predeterminated == false) {
                reportingService.testReport(vm.modulos.selected.id, relatedTables, fields, filters, orders).then(function (result) {
                    vm.loadingInformation = true;
                    $('#report-container').html(result.data);
                });
            } else {
                reportingService.testCloned(id, fields, filters, orders).then(function (result) {
                    vm.loadingInformation = true;
                    $('#report-container').html(result.data);
                });
            }
        }


        //#endregion

        //#region ---------------------------------CUSTOM FILTERS--------------------------------------
        function predeterminatedOriginalFiltersFilter(item) {
            return item.added == true;
        }

        function customRelationFilter(item) {
            item.filter = false;
            var bool = false;
            if (vm.searchText == "") bool = true;
            else if (item.relatedTable.description.toLowerCase().includes(vm.searchText)) {
                bool = true;
                item.filter = true;
            } else {
                for (var i = 0; i < item.fields.length; i++) {
                    if (item.fields[i].nombre.includes(vm.searchText)) {
                        bool = true;
                        break;
                    }
                }
            }
            if (vm.searchText != "") item.show = true;
            return bool;
        }

        function customFieldFilter(item) {
            var bool = false;
            if (vm.searchText == "") bool = true;
            else if (item.nombre.includes(vm.searchText)) bool = true;
            else {
                for (var i = 0; i < vm.relationsShow.length; i++) {
                    if (vm.relationsShow[i].fields.findIndex(x => x.id == item.id) != -1) {
                        if (vm.relationsShow[i].filter == true) {
                            bool = true;
                        }
                        break;
                    }
                }
            }

            return bool;
        }
        //#endregion

        //#region ---------------------------------GET DATA SPECIAL--------------------------------------

        function getOperatorsData(filter) {
            if (filter == null) return [];
            var idx = vm.filters.findIndex(x => x.columnExtendedId == filter.columnExtendedId);
            if (idx > -1) {
                return vm.filters[idx].operators;
            } else return [];
        }

        function getFilterData(filter) {
            if (filter == null) return [];
            var idx = vm.filters.findIndex(x => x.columnExtendedId == filter.columnExtendedId);
            if (idx > -1) {
                return vm.filters[idx].data;
            } else return [];
        }

        function hasFilterData(filter) {
            if (filter == null) return false;
            var idx = vm.filters.findIndex(x => x.columnExtendedId == filter.columnExtendedId);
            if (idx > -1) {
                return vm.filters[idx].data != null;
            } else return false;
        }

        //#endregion

        //#region ---------------------------------FILTRO EMPRESAS--------------------------------------
        function removeEmpresa(empresa) {
            vm.filter.input.splice(vm.filter.input.findIndex(x => x.empresaId == empresa.empresaId), 1);
            vm.filter.data.push(empresa);
            if (vm.filter.input.length == 0) {
                vm.filter.input = JSON.parse(JSON.stringify(vm.filter.originalData));
            }
        }

        function addEmpresa(empresa) {
            if (vm.filter.input.length == vm.filter.originalData.length) {
                vm.filter.input = [];
            }
            vm.filter.input.push(empresa);
            vm.filter.data.splice(vm.filter.data.findIndex(x => x.empresaId == empresa.empresaId), 1);
            if (vm.filter.data.length == 0) {
                vm.filter.expanded = false;
                vm.filter.data = JSON.parse(JSON.stringify(vm.filter.originalData));
            }
        }
        //#endregion

    }
})();